<template>
  <v-row class="table-history">
    <v-col cols="12" class="fill-height">
      <v-card class="fill-height" style="overflow: auto;">
        <v-card-text>
          <v-row>
            <v-col :offset="(12 - colsFit) / 2" :cols="colsFit">
              <v-list dense>
                <v-list-item>
                  <v-list-item-content class="board" style="justify-content: center">
                    <poker-hand :hh="hand"></poker-hand>
                  </v-list-item-content>
                </v-list-item>
                <v-card-actions>
                  <v-row>
                    <v-col cols="12" class="d-flex justify-center" style="gap: 10px;">
                      <v-btn color="secondary" :disabled="loadingHand" @click="loadHand(0)">First</v-btn>
                      <v-btn color="primary"
                             @click="loadHand(hand.prev_hand)" :disabled="!hand || !hand.prev_hand || loadingHand">
                        Hand #{{ hand ? hand.prev_hand || hand.handNum - 1 : '?' }}
                      </v-btn>
                      <v-btn color="secondary" :disabled="loadingHand" @click="seeTracker(hand)" v-if="hand">Details</v-btn>
                      <v-btn color="primary"
                             @click="loadHand(hand.next_hand)" :disabled="!hand || !hand.next_hand || loadingHand">
                        Hand #{{ hand ? hand.next_hand || hand.handNum + 1 : '?' }}
                      </v-btn>
                      <v-btn color="secondary" @click="loadHand(-1)" :disabled="loadingHand">Last</v-btn>

                      <v-progress-circular indeterminate v-if="loadingHand" color="primary"></v-progress-circular>
                    </v-col>
                  </v-row>
                </v-card-actions>

                <apexchart type="line" :options="options" :series="series"></apexchart>

                <template v-if="series.length && evDescription">
                  <p v-for="k of Object.keys(evDescription)" :key="k"> * {{ evDescription[k] }}</p>
                </template>

              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <v-dialog v-model="askTracker" width="600">
      <v-card>
        <v-card-title>Hand # {{ tracker.hand_num }} - {{ tracker.displayID }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <pre style="white-space: pre-wrap">{{ tracker.pokertracker_txt }}</pre>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="askTracker=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import PokerHand from "./chat/PokerHand";

export default {
  name: "MiningTable",
  components: {PokerHand},
  props: {
    hand: Object,
    colsFit: {
      type: Number,
      default: 12
    }
  },
  data() {
    return {
      RANKS: '__23456789TJQKA',
      SUITS: '_cdhs',

      askTracker: false,
      tracker: {},

      askShareHand: false,
      handSharing: {},

      options: {
        chart: {
          id: 'vuechart-example'
        },
        xaxis: {
          categories: ["Pre-flop", "Flop", "Turn", "River"],
          labels: {
            style: {
              fontSize: '16px'
            }
          },
        },
        yaxis: {
          labels: {
            style: {
              fontSize: '16px'
            },
            formatter: (v) => {
              return `${v}%`;
            }
          },
          min: 0,
          max: 100
        },
        stroke: {
          curve: 'smooth'
        },
        theme: {
          mode: 'dark',
          palette: 'palette1',
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "14px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: "bold"
          },
          formatter: (v) => {
            return `${v}%`;
          }
        },
        legend: {
          fontSize: "16px"
        },
        tooltip: {
          style: {
            fontSize: '16px'
          }
        }
      },
      series: [],

      loadingHand: false,
      evDescription: ""
    };
  },
  watch: {
    currentHandId() {
      // update ev on hand change
      this.loadEvs();
    }
  },
  computed: {
    currentHandId() {
      if (!this.hand) return null;
      return this.hand._id;
    },
    apiHand() {
      if (!this.hand) return {};
      return this.hand.api_hand;
    },
    communityCards() {
      if (!this.hand) return [];
      return this.decodeCards(this.hand.communityCards);
    },
  },

  methods: {
    loadHand(hand_num) {
      this.$emit("loadHand", {
        room_id: this.hand.room_id,
        hand_num: hand_num
      });
    },
    loadEvs() {
      let url = "/api/get_evs";

      let board = this.communityCards;
      let players = {};

      let nameById = {};

      for (let player of this.apiHand.players) {
        nameById[player.id] = player.nickname;
      }

      if (this.apiHand.result && this.apiHand.result.players_info) {
        for (let player of this.apiHand.result.players_info || []) {

          if (!player.shown || !player.shown.length) continue;

          players[nameById[player.playerId]] = player.shown;
        }
      }

      if (Object.keys(players).length < 2) {
        this.series = [];
        this.evDescription = "";
        return;
      }

      let handId = null;

      if (this.hand) {
        handId = this.hand._id;
      }

      this.$axios.post(url, {
        "players": players,
        "cards": board,
        "hand_id": handId
      }).then((res) => {
        const data = res.data;

        this.series = [];
        this.evDescription = "";

        if (data.is_interesting_hand) {
          this.evDescription = data.description;
        }

        for (let k of Object.keys(data.evs)) {
          let d = data.evs[k];

          this.series.push({
            name: k,
            data: [
              `${(d.pre_flop.ev*100).toFixed(1)}`,
              `${(d.flop.ev*100).toFixed(1)}`,
              `${(d.turn.ev*100).toFixed(1)}`,
              `${(d.river.ev*100).toFixed(1)}`]
          })
        }
      })
    },

    playersInHand(st) {
      let players = [];
      for (let k in st.players) {
        let p = st.players[k];
        if (p.result !== 0 && p.actions.length > 0) {
          players.push(p);
        }
      }
      return players;
    },
    getResult(st, p) {
      let d = st.settings.withDecimal ? 100 : 1;
      return (p.result / d).toFixed(2);
    },
    showed(st, p) {
      return (('' + p.seat) in st.showdowns) ;
    },

    seeTracker(hand) {
      this.askTracker = true;
      this.tracker = {...hand};
    },

    decodeCard(c) {
      return this.RANKS[c["rank"]] + this.SUITS[c["color"]];
    },

    decodeCards(cards) {
      if (!cards || !cards.length) return [];
      return cards.map(el => this.decodeCard(el));
    },
  }
}
</script>

<style scoped>
.table-history {
  height: 100% !important;
  min-height: 300px;
  margin: 0;
}

.table-history > div {
  padding: 0;
}

.board {
  overflow: visible;

  padding: 10% 0 !important;
}

.share-hand {
  position: absolute;

  background-color: #639526 !important;

  top: -10px;
}
</style>
